import type { DefaultTheme } from 'styled-components';

export const defaultTheme: DefaultTheme = {
  picture: {},
  button: {},
  title: {},
  features: {},
  price: {},
  column: {},
  form: {},
  headColumn: {},
  highlight: {},
  popup: {}
};
